import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddDormatService } from './add-dormat.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
  selector: 'gtw-add-dormat',
  templateUrl: './add-dormat.component.html',
  styleUrls: ['./add-dormat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddDormatComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  // Flags to prevent duplicate initialization
  private isInitialized = false;
  private isLoading = false;

  // Component data
  baseURLs: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};
  gridData: any[] = [];

  // Component properties
  title = 'Add Dormat';
  minimise = false;
  entities: any[] = [];
  btnDisabled = false;
  crudLoading = false;
  cc_keys: any[] = [];

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      let urls = safeJsonInput<any>(baseUrls, null, 'add-dormat.parse1');
      if (Object.keys(urls).length > 0) {
        this.baseURLs = urls;
        this.tryInit();
      }
    } catch (e) {
      console.log("Input Not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      let params = safeJsonInput<any>(filterParams, null, 'add-dormat.parse2');
      if (Object.keys(params).length > 0) {
        this.filterParams = params;
        this.tryInit();
      }
    } catch (e) {
      console.log("Filter params input not yet stable.");
    }
  }

  @Input('header-data')
  set headerData(headerData: any) {
    try {
      this.globalService = safeJsonInput<any>(headerData, null, 'add-dormat.parse3');
      this.GENERAL_CONFIG = this.globalService.generalConfigData;
      this.tryInit();
    } catch (e) {
      console.log("Input Not yet stable.");
    }
  }

  @Input('row-data')
  set _rowData(rowData: string) {
    try {
      this.rowData = safeJsonInput<any>(rowData, null, 'add-dormat.parse4');
      this.tryInit();
    } catch (e) {
      console.log("Row data input not yet stable.");
    }
  }

  @Input('grid-data')
  set _gridData(gridData: string) {
    try {
      this.gridData = safeJsonInput<any>(gridData, null, 'add-dormat.parse5');
      this.tryInit();
    } catch (e) {
      console.log("Grid data input not yet stable.");
    }
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private addDormatService: AddDormatService
  ) {}

  ngOnInit(): void {
    // Initial setup done via inputs
  }

  // Gate function to prevent duplicate initialization
  private tryInit() {
    if (this.isInitialized || this.isLoading) {
      return;
    }

    // Check if ALL required data is present before initializing
    if (!this.globalService || !this.GENERAL_CONFIG || !this.gridData || this.gridData.length === 0) {
      return;
    }

    this.isInitialized = true;
    this.init();
  }

  init() {
    try {
      this.crudLoading = false;

      // Handle single object or array from gridData
      if (!Array.isArray(this.gridData)) {
        const obj: any = {};
        obj.row_id = (this.gridData as any).rowData?.object_id;
        obj.data = (this.gridData as any).rowData;
        this.gridData = [obj];
      }

      // Clone entities from gridData
      this.entities = [...this.gridData];
      console.log("entities", this.entities);

      this.cdr.detectChanges();
    } catch (e) {
      console.error('Error in init:', e);
      this.cdr.detectChanges();
    }
  }

  saveDormat() {
    // Prevent double-click
    if (this.crudLoading) {
      this._snackBar.open('Please wait while we save this request', 'Close', {
        duration: 4000,
        panelClass: ['info-snackbar']
      });
      return;
    }

    this.btnDisabled = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const url = this.GENERAL_CONFIG.base_url + "/saveJsonObject?action_code=fdsa48";
    this.cc_keys = [];

    // Filter entities where TB_LOADED is empty or not equal to 1
    this.entities.forEach((item: any) => {
      if (item.data && item.data.TB_LOADED === "") {
        this.cc_keys.push({ cc_key: (item.data.COMBINATION_KEY || item.data.CC_KEY) });
      } else if (item.data && item.data.TB_LOADED && item.data.TB_LOADED != 1) {
        this.cc_keys.push({ cc_key: (item.data.COMBINATION_KEY || item.data.CC_KEY) });
      }
    });

    console.log("****cc_keys****", this.cc_keys);

    const params = {
      tax_year: this.entities[0]?.data?.TAX_YEAR,
      cc_keys: JSON.stringify(this.cc_keys),
      status: 1,
      del_flag: 'N'
    };

    console.log("****cc_keys****", params);

    if (this.cc_keys && this.cc_keys.length > 0) {
      // Merge global params, filter params and specific params
      const mergedParams = {
        ...this.globalService?.globalParams,
        ...this.filterParams,
        ...params
      };

      this.addDormatService.addDormat(url, mergedParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (response: any) => {
          this.btnDisabled = false;
          this.crudLoading = false;

          if (response && response.callSuccess === "1") {
            this._snackBar.open('TB Inactive saved successfully', 'Close', {
              duration: 4000,
              panelClass: ['success-snackbar']
            });

            this.requestGridUpdate.emit('refresh');
          } else {
            this._snackBar.open(response?.errorMessage || 'Error occurred', 'Close', {
              duration: 4000,
              panelClass: ['error-snackbar']
            });
          }
          this.cdr.detectChanges();
        },
        (error: any) => {
          this.btnDisabled = false;
          this.crudLoading = false;
          console.error('Error saving dormat:', error);
          this._snackBar.open('Error occurred while saving. Please try again.', 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
          this.cdr.detectChanges();
        }
      );
    } else {
      this._snackBar.open('Please select the empty circle records', 'Close', {
        duration: 4000,
        panelClass: ['warning-snackbar']
      });
      this.btnDisabled = false;
      this.crudLoading = false;
      this.cancel();
      this.cdr.detectChanges();
    }
  }

  removeEntity(index: number) {
    this.entities.splice(index, 1);
    if (this.entities.length === 0) {
      this.requestGridUpdate.emit('cancel');
    }
    this.cdr.detectChanges();
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
